interface IRenderTitle {
    title: string;
  }
  const RenderTitle = ({ title }: IRenderTitle) => {
    return <span>{title}</span>
  }

  export default RenderTitle;
